import type { IconData } from '@stacksjs/iconify-core'

export const recycleBin3: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M7.75 32s3.482 1 16.25 1s16.25-1 16.25-1M6.5 20s3.75 1 17.5 1s17.5-1 17.5-1m3.276-12.465c-.299.886-1.262 1.198-2.196 1.235C40.32 8.858 34.993 9 24 9S7.679 8.858 5.42 8.77c-.934-.037-1.897-.349-2.196-1.235C3.095 7.147 3 6.645 3 6s.094-1.147.224-1.535c.299-.886 1.262-1.198 2.196-1.235C7.68 3.142 13.007 3 24 3s16.321.142 18.58.23c.934.037 1.897.349 2.196 1.235c.13.388.224.89.224 1.535s-.094 1.147-.224 1.535\"/><path d=\"M5.153 8.751c1.787 20.136 3.549 29 4.37 32.319c.276 1.121.989 2.048 2.08 2.428C13.473 44.15 17.215 45 24 45s10.526-.85 12.397-1.502c1.091-.38 1.804-1.307 2.081-2.428c.82-3.318 2.582-12.183 4.369-32.319M24 9v36\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default recycleBin3
